export const NAME = 'folders';
